export default __webpack_public_path__ + "static/media/Snd_CP.d82a385a.mp3";